export const selectProjectInfo = (state) => state.info.projectInfo
export const selectLegalInfo = (state) => state.info.legalInfo
export const selectCardContent = (state) => state.info.cardContent
